import { useInactivityLogout } from "@/hooks/useInactivityLogout";
import { InactivityWarningDialog } from "./InactivityWarningDialog";

export function InactivityLogoutProvider() {
  const { showWarning, remainingTime, stayLoggedIn } = useInactivityLogout();

  return (
    <InactivityWarningDialog
      open={showWarning}
      remainingTime={remainingTime}
      onStayLoggedIn={stayLoggedIn}
    />
  );
}
